import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiService } from './api.service';
import { NotificationService } from '../notification.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Critter } from '@app/infrastructure/models/critter';

@Injectable({
  providedIn: 'root',
})
export class CritterService {
  // TODO: Change route when the API is updated
  private controllerRoute: string = 'critters';
  private url: string = `${environment.apiRoute}`;

  constructor(
    private apiService: ApiService,
    private notificationService: NotificationService,
  ) {
    this.url = `${environment.apiRoute}/${this.controllerRoute}`;
  }

  public getList(): Observable<Critter[]> {
    const endpoint = `${this.url}`;

    return this.apiService.get<Critter[]>(endpoint);
  }

  public find(id: number): Observable<Critter> {
    const endpoint = `${this.url}/${id}`;

    return this.apiService.get<Critter>(endpoint);
  }

  public create(payload: Critter): Observable<Critter> {
    const endpoint = `${this.url}`;
    return this.apiService.post<Critter, Critter>(endpoint, payload);
  }

  public update(payload: Critter, Id: number): Observable<Critter> {
    const endpoint = `${this.url}/${Id}`;

    return this.apiService.patch<Critter, Critter>(endpoint, payload);
  }

  public delete(critter: Critter): Observable<Critter> {
    const endpoint = `${this.url}/${critter.id}`;

    return this.apiService.delete<Critter>(endpoint);
  }
}
